<script setup lang="ts">
import type { Product } from '~/types/shopware'
import { getProductLabels } from '~/lib/utils/shopware'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  product: Product
}>()

const labels = computed(() => getProductLabels(props.product))
</script>
<template>
  <div v-animate="{ cluster: 'true' }" class="labels">
    <div v-if="labels.new" v-animate="{ animation: 'vertical-reveal' }" class="label">
      {{ t('shop.listingPage.labels.new') }}
    </div>
    <div v-if="labels.onSale" v-animate="{ animation: 'vertical-reveal' }" class="label">
      {{ t('shop.listingPage.labels.onSale') }}
    </div>
    <div v-if="labels.soon" v-animate="{ animation: 'vertical-reveal' }" class="label">
      {{ t('shop.listingPage.labels.soon') }}
    </div>
    <div v-if="labels.willBeReplaced" v-animate="{ animation: 'vertical-reveal' }" class="label">
      {{ t('shop.listingPage.labels.willBeReplaced') }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
.labels {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  .label {
    padding: 10px 14px;
    border-radius: 5px;
    background-color: var(--c-green-dark-100);
    color: var(--c-white);
  }
}
</style>
